// The staff build controls where newly generated guest links point. Leaving
// this unset preserves existing deployments on the current app origin.
export function guestMenuUrl(tableToken) {
  const origin = process.env.REACT_APP_GUEST_MENU_ORIGIN?.trim() || window.location.origin;
  return new URL(`/order/${encodeURIComponent(tableToken)}`, origin).href;
}

export const guestMenuPreviewUrl = tableToken => `${guestMenuUrl(tableToken)}/preview`;
